// Version : 0.0.1
// Author : VISHAL,ARANVINDHAN,VISHNU
// LastEdit : SHIYAM
// MODFIED DATE : 01-08-2025

const EconomicActivityActionTypes = {
	/** ***************** GET ECONOMIC ACTIVITY  LIST START *********************** */
	GET_ECONOMIC_ACTIVITY_LIST_START: 'get_economic_activity_list_start',
	GET_ECONOMIC_ACTIVITY_LIST_SUCCESS: 'get_economic_activity_list_success',
	GET_ECONOMIC_ACTIVITY_LIST_FAILURE: 'get_economic_activity_list_failure',
	GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_RESET: 'get_economic_activity_list_response_reset',
	GET_ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED: 'get_economic_activity_list_response_changed',
	/** ***************** GET ECONOMIC ACTIVITY  LIST END *********************** */

	/******************* DELETE ECONOMIC ACTIVITY DETAILS START *********************** */
	DELETE_ECONOMIC_ACTIVITY_DETAILS_START: 'delete_economic_activity_details_start',
	DELETE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS: 'delete_economic_activity_details_success',
	DELETE_ECONOMIC_ACTIVITY_DETAILS_FAILURE: 'delete_economic_activity_details_failure',
	DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET:
		'delete_economic_activity_details_response_reset',
	DELETE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
		'delete_economic_activity_details_response_changed',
	/******************* DELETE ECONOMIC ACTIVITY DETAILS END *********************** */

	/******************* ADD ECONOMIC ACTIVITY DETAILS START *********************** */
	ADD_ECONOMIC_ACTIVITY_DETAILS_START: 'add_economic_activity_details_start',
	ADD_ECONOMIC_ACTIVITY_DETAILS_SUCCESS: 'add_economic_activity_details_success',
	ADD_ECONOMIC_ACTIVITY_DETAILS_FAILURE: 'add_economic_activity_details_failure',
	ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET: 'add_economic_activity_details_response_reset',
	ADD_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
		'add_economic_activity_details_response_changed',
	/******************* ADD ECONOMIC ACTIVITY DETAILS END *********************** */

	/******************* UPDATE ECONOMIC ACTIVITY DETAILS START *********************** */
	UPDATE_ECONOMIC_ACTIVITY_DETAILS_START: 'update_economic_activity_details_start',
	UPDATE_ECONOMIC_ACTIVITY_DETAILS_SUCCESS: 'update_economic_activity_details_success',
	UPDATE_ECONOMIC_ACTIVITY_DETAILS_FAILURE: 'update_economic_activity_details_failure',
	UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET:
		'update_economic_activity_details_response_reset',
	UPDATE_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
		'update_economic_activity_details_response_changed',
	/******************* UPDATE ECONOMIC ACTIVITY DETAILS START *********************** */

	/******************* FETCH ECONOMIC ACTIVITY DETAILS START *********************** */
	FETCH_ECONOMIC_ACTIVITY_DETAILS_START: 'fetch_economic_activity_details_start',
	FETCH_ECONOMIC_ACTIVITY_DETAILS_SUCCESS: 'fetch_economic_activity_details_success',
	FETCH_ECONOMIC_ACTIVITY_DETAILS_FAILURE: 'fetch_economic_activity_details_failure',
	FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_RESET:
		'fetch_economic_activity_details_response_reset',
	FETCH_ECONOMIC_ACTIVITY_DETAILS_RESPONSE_CHANGED:
		'fetch_economic_activity_details_response_changed',
	/******************* DELETE ECONOMIC ACTIVITY DETAILS END *********************** */
};
export default EconomicActivityActionTypes;
